import "./site-template-preview.css";
import type { CSSProperties } from "react";

type TemplateConfig = { layout?: string; colors?: { accent?: string; background?: string; surface?: string; text?: string } };

export function SiteTemplatePreview({ config, name }: { config: Record<string, unknown>; name: string }) {
  const typed = config as TemplateConfig;
  const layout = typed.layout ?? "avenida", colors = typed.colors ?? {};
  return <div className={`template-preview preview-${layout}`} style={{"--preview-accent":colors.accent??"#49f5c1","--preview-bg":colors.background??"#071512","--preview-surface":colors.surface??"#10241f","--preview-text":colors.text??"#fff"} as CSSProperties} aria-label={`Pré-visualização ${name}`}>
    <header><b>{name.slice(0,1)}</b><nav><i/><i/><i/></nav></header>
    <section className="preview-hero"><small>STAND AUTOMÓVEL</small><strong>A próxima viatura começa aqui.</strong><span/><em>Ver stock</em></section>
    <section className="preview-search"><i/><i/><i/></section>
    <section className="preview-cars"><article><i><img src="/demo-volvo-xc40.png" alt="" /></i><b/><span/></article><article><i/><b/><span/></article><article><i/><b/><span/></article></section>
  </div>;
}
